// workaround because we cannot specify a root directory for npm
module.exports = require("./lib/ifly-i18n");